import { combineReducers } from 'redux';
import toolbox from './toolbox-reducers';

import {
  SET_DROP_PREVIEW_INDEX_PATH,
  RESET_DROP_PREVIEW_INDEX_PATH
} from '../actions/action-names';

const reduceDeviceState = (device, state, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dropPreviewIndexPath = (state = null, action) => {
  switch (action.type) {
    case SET_DROP_PREVIEW_INDEX_PATH:
      const { columnId, index } = action;
      return { columnId, index };

    case RESET_DROP_PREVIEW_INDEX_PATH:
      return null;

    default:
      return state;
  }
};

const desktop = (state = {}, action) => {
  return reduceDeviceState('desktop', state, action);
};

const tablet = (state = {}, action) => {
  return reduceDeviceState('tablet', state, action);
};

const mobile = (state = {}, action) => {
  return reduceDeviceState('mobile', state, action);
};

export default combineReducers({
  dropPreviewIndexPath,
  desktop,
  tablet,
  mobile,
  toolbox
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/viewmodel-reducers.js